import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, BookOpenIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
const items = [{
  icon: <BookOpenIcon className="w-6 h-6 text-[#E69D4F]" data-id="element-175" />,
  name: 'The Backyard Pitmaster',
  desc: 'The 30-day "Heat-Flow" Blueprint — Complete Digital Guide',
  value: '$17'
}];
export function ValueStack() {
  const {
    formatted,
    isUrgent
  } = useCountdown(14, 8);
  return <section id="pricing" className="py-16 md:py-20 px-4 bg-dark" data-id="element-176">
      <div className="max-w-4xl mx-auto" data-id="element-177">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-178">
          <h2 className="font-heading text-4xl md:text-5xl font-black text-ivory mb-2 uppercase tracking-tight" data-id="element-179">
            Get Your Copy of
          </h2>
          <h2 className="font-heading text-5xl md:text-6xl font-black text-[#E69D4F] uppercase tracking-tight" data-id="element-180">
            The Backyard Pitmaster
          </h2>
        </motion.div>

        {/* Product Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="w-full rounded-2xl overflow-hidden mb-10" data-id="element-181">
          <img src="https://cdn.magicpatterns.com/uploads/4ErqEDMZ7VNVqmiYGkkFpp/The_Backyard_Pitmaster.png" alt="The Backyard Pitmaster - Texas-Quality BBQ on a Budget" className="w-full h-auto object-cover" data-id="element-182" />
        </motion.div>

        {/* Value Table */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="rounded-2xl overflow-hidden border border-[#3A2A1A] mb-10 bg-[#1C1410]" data-id="element-183">
          {/* Orange gradient header */}
          <div className="bg-gradient-to-r from-[#E69D4F] to-[#C45F2A] px-4 py-3 md:px-8 md:py-5 border-b-4 border-[#964215]" data-id="element-184">
            <h3 className="font-heading text-xl md:text-3xl font-black text-[#0F1111] uppercase tracking-tight" data-id="element-185">
              What You Get Today
            </h3>
          </div>

          {/* Item */}
          <div className="flex flex-col" data-id="element-186">
            {items.map((item, index) => <div key={index} className="px-6 sm:px-8 py-6 flex items-center gap-5" data-id="element-187">
                <div className="shrink-0 text-[#E69D4F] opacity-70" data-id="element-188">
                  {item.icon}
                </div>
                <div className="flex-1 min-w-0" data-id="element-189">
                  <h4 className="text-ivory font-bold text-lg leading-tight" data-id="element-190">
                    {item.name}
                  </h4>
                  <p className="text-[#8A7A6A] text-sm mt-1" data-id="element-191">{item.desc}</p>
                </div>
                <div className="text-[#E69D4F] font-heading font-bold text-xl sm:text-2xl shrink-0" data-id="element-192">
                  {item.value}
                </div>
              </div>)}
          </div>

          {/* Total Value Footer */}
          <div className="border-t-2 border-[#3A2A1A] px-6 sm:px-8 py-6 flex justify-between items-end bg-[#161010]" data-id="element-193">
            <div data-id="element-194">
              <p className="text-[#8A7A6A] text-sm font-heading uppercase tracking-widest mb-1" data-id="element-195">
                Regular Price
              </p>
              <p className="text-[#E69D4F] font-heading font-black text-3xl sm:text-4xl md:text-5xl line-through decoration-[#8A7A6A]/50" data-id="element-196">
                $17
              </p>
            </div>
            <div className="text-right" data-id="element-197">
              <p className="text-[#8A7A6A] text-sm font-heading uppercase tracking-widest mb-1" data-id="element-198">
                Today Only
              </p>
              <p className="text-[#E69D4F] font-heading font-black text-4xl sm:text-5xl md:text-6xl" data-id="element-199">
                $6.36
              </p>
            </div>
          </div>
        </motion.div>

        {/* Price Box */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-b from-dark-elevated to-dark border-2 border-[#E69D4F]/60 rounded-2xl md:rounded-3xl p-6 sm:p-10 md:p-16 text-center relative shadow-[0_0_60px_rgba(230,157,79,0.12)]" data-id="element-200">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-gradient-to-r from-[#F2B851] to-[#C45F2A] text-[#0F1111] px-8 py-2 rounded-full font-black text-sm tracking-widest uppercase" data-id="element-201">
            Best Value
          </div>

          <p className="font-heading text-ivory text-2xl sm:text-3xl md:text-4xl font-bold mb-2 uppercase tracking-tight" data-id="element-202">
            Today Only:
          </p>

          <div className="flex justify-center items-baseline gap-1 mb-4" data-id="element-203">
            <span className="text-[#E69D4F] text-3xl sm:text-5xl font-black" data-id="element-204">
              $
            </span>
            <span className="text-[#E69D4F] text-6xl sm:text-8xl md:text-9xl font-black leading-none tracking-tighter" data-id="element-205">
              6.36
            </span>
          </div>

          <p className="text-green-500 font-bold text-lg sm:text-2xl mb-4" data-id="element-206">
            You save $10.64 (63% OFF)
          </p>

          {/* Timer Box */}
          <div className="inline-flex items-center gap-2 sm:gap-3 bg-dark border border-[#E69D4F]/40 rounded-lg px-4 sm:px-6 py-2 sm:py-3 mb-6 sm:mb-10" data-id="element-207">
            <span className="text-smoke text-sm font-medium" data-id="element-208">
              Offer expires in:
            </span>
            <motion.span animate={isUrgent ? {
            color: ['#E69D4F', '#FFD700', '#E69D4F']
          } : {}} transition={{
            duration: 1,
            repeat: Infinity
          }} className="font-mono text-[#E69D4F] text-xl font-bold tracking-widest" data-id="element-209">
              {formatted}
            </motion.span>
          </div>

          <div className="mb-8" data-id="element-210">
            <button onClick={() => document.getElementById('final-cta')?.scrollIntoView({
            behavior: 'smooth'
          })} className="w-full bg-gradient-to-r from-[#F2B851] to-[#C45F2A] border-b-4 border-[#964215] rounded-md text-[#0F1111] font-black uppercase text-base sm:text-xl md:text-2xl py-4 sm:py-6 px-4 sm:px-8 shadow-[0_0_25px_rgba(242,184,81,0.4)] hover:brightness-110 hover:-translate-y-0.5 active:translate-y-0.5 active:border-b-2 transition-all duration-200" data-id="element-211">
              🔥 GET INSTANT ACCESS — $6.36 →
            </button>
          </div>

          <div className="flex flex-col items-center gap-4 text-smoke text-sm" data-id="element-212">
            <div className="flex gap-3" data-id="element-213">
              <div className="w-12 h-8 bg-dark border border-[#333] rounded flex items-center justify-center text-[10px] font-bold text-smoke" data-id="element-214">
                VISA
              </div>
              <div className="w-12 h-8 bg-dark border border-[#333] rounded flex items-center justify-center text-[10px] font-bold text-smoke" data-id="element-215">
                MC
              </div>
              <div className="w-12 h-8 bg-dark border border-[#333] rounded flex items-center justify-center text-[10px] font-bold text-smoke" data-id="element-216">
                AMEX
              </div>
              <div className="w-12 h-8 bg-dark border border-[#333] rounded flex items-center justify-center text-[10px] font-bold text-smoke" data-id="element-217">
                PP
              </div>
            </div>
            <div className="flex items-center gap-2 text-base mt-2" data-id="element-218">
              <LockIcon size={16} data-id="element-219" />
              <span data-id="element-220">Secure 256-bit Encrypted Checkout</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}